import { connect } from "react-redux";
import { providePopulateData } from "components/utility/hoc/PopulateData";
import moment from 'moment';
import DatePicker from 'react-datepicker';

var CurrentUser = require("lib/account/CurrentUser");
var DropDownOptions = require("components/utility/DropDownOptions");
var SchoolYearMonthsPreference = require("components/users/teachers/preferences/SchoolYearMonthsPreference");
var ExpectationPeriodPreference = require("components/org/preferences/ExpectationPeriodPreference");
var GradeLevelExpectationsPreference = require("components/org/preferences/GradeLevelExpectationsPreference");

var RosterSelectors = require("lib/selectors/RosterSelectors");
var RosterActions = require("lib/actions/RosterActions");

require("org/preferences/school_contest_preference.scss");

@connect(
	(state, props) => {
		var selectedSchoolOrgs = []
		var admin = RosterSelectors.admin({state, id:CurrentUser.get().id})
		var refPrefs = {}

		if (CurrentUser.isSchoolAdmin()) {
			if (admin.org_ids.school_orgs && admin.org_ids.school_orgs.all) {
				var selectedSchoolOrgs = RosterSelectors.schoolOrgs({
					state, conditions: { ids: admin.org_ids.school_orgs.all }
				})
			}
		} else {
			if (admin.org_ids.district_orgs && admin.org_ids.district_orgs.primary) {
				var selectedDistrictOrg = RosterSelectors.districtOrg({
					state, id: admin.org_ids.district_orgs.primary[0] })
				
				if (selectedDistrictOrg) {
					var selectedSchoolOrgs = RosterSelectors.schoolOrgs({
						state, conditions: { ids: _.map(selectedDistrictOrg.school_orgs, (so) => so.id) }
					})
				}
				
			}
		}

		return {
			admin,
			selectedSchoolOrgs,
			prefs: {}
		}
	},

	(dispatch, props) => ({
		populateData: () => {
            //STEP 1: Grab logged in admin
            return Promise.all([ dispatch(RosterActions.fetchAdmins({
                filters:{ids: [CurrentUser.get().id]}, 
                embeds:['admin.org_ids'],
                cache: false
            })).then(response=>{
            	var currentAdmin = response.admins[0]
            	if (currentAdmin) {
            		if (CurrentUser.isSchoolAdmin()) {
	            		if (currentAdmin.org_ids && currentAdmin.org_ids.school_orgs && currentAdmin.org_ids.school_orgs.all) {
	            			return Promise.all([ dispatch(RosterActions.fetchSchoolOrgs({
				                filters: {ids: currentAdmin.org_ids.school_orgs.all}, 
				                embeds:['school_org.prefs'],
				                cache: false
				            }))])
	            		}
	            	} else {
	            		if (currentAdmin.org_ids && currentAdmin.org_ids.district_orgs && currentAdmin.org_ids.district_orgs.primary) {
	            			return Promise.all([ dispatch(RosterActions.fetchDistrictOrgs({
				                filters: { ids: currentAdmin.org_ids.district_orgs.primary}, 
				                embeds: ['district_org.school_orgs,school_org.prefs'],
				                cache: false
				            }))])
	            		}
	            	}
            	}
            })])
        },
		onChange: (schoolOrg, message) => {
			// Will get moved to redux at some point (soon, I hope)
			window.wrNotifications.triggerDropDownNotification({
				title: "Contest Information Edited", text: message, icon: "ok-sign"
			});

			return dispatch(RosterActions.updateSchoolOrgPrefs({
				currentUserID: CurrentUser.get().id,
				schoolOrgID: schoolOrg.id,
				update: {"school_contests": schoolOrg.prefs.school_contests}
			}))
		}
	})
)

@providePopulateData({waitForLoad:true})

class SchoolContestPreference extends React.Component {
	constructor(props) {
		super();
		autobind(this);
		LuckyOrangeClient.tagComponent("SchoolContestPreference");
		this.state = {selectedSchoolOrgs: props.selectedSchoolOrgs, save: [],
		 selectedReadingMetric: "minutes_read", selectedWritingMetric: "all_writing"}
	}
	getSchoolIndex(school) {
		var indexes = _.map(this.state.selectedSchoolOrgs, (s) => {return s.id})
		return indexes.indexOf(school.id)
	}

	setValueOnSchoolPref(school, key, value) {
		var index = this.getSchoolIndex(school)
		var selectedSchoolOrgs = this.state.selectedSchoolOrgs
		if (selectedSchoolOrgs) {
			selectedSchoolOrgs[index].prefs.school_contests[0][key] = value;
			this.state.save.push(school.id)
			this.setState({selectedSchoolOrgs, save: this.state.save})
		}
	}
	selectStartDate(school, startDate) {
		this.setValueOnSchoolPref(school, "start_date", moment(startDate).format("YYYY-MM-DD"))
	}

	selectEndDate(school, endDate) {
		this.setValueOnSchoolPref(school, "end_date", moment(endDate).format("YYYY-MM-DD"))
	}

	onSelectReadingMetric(school, selected) {
		this.setValueOnSchoolPref(school, "reading_metric", selected.target.value)
	}

	onSelectWritingMetric(school, selected) {
		this.setValueOnSchoolPref(school, "writing_metric", selected.target.value)
	}

	onSetGoal(school, metric, input) {
		this.setValueOnSchoolPref(school, metric, input.target.value)
	}

	renderselectedSchoolOrgs() {
		return _.map(this.state.selectedSchoolOrgs, (school) => {
			if (!school.prefs || !school.prefs.school_contests || _.isEmpty(school.prefs.school_contests)) {
				return ""
			}
			if (this.state.save.includes(school.id)) {
				var saveAction = (
					<div className="saveAction">
						<button className="btn btn-primary" onClick={this.onSave.bind(this, school)}>Save</button>
					</div>
				)
			}
			var contest = school.prefs.school_contests[0]
			return (
				<div key={school.id} className="classSection">
					<h2> { school.name } </h2>

					<div className="dateSection">
						<label>
							<span>Start</span>
							<DatePicker className="startDatePicker"
								onChange={this.selectStartDate.bind(this,school)}
								selected={moment(contest.start_date)} />
						</label>
						<label>
							<span>End</span>
							<DatePicker className="startDatePicker"
								onChange={this.selectEndDate.bind(this,school)}
								selected={moment(contest.end_date)} />
						</label>
					</div>
					<div className="metricSection">
						<table className="table">
							<thead>
								<tr>
									<th>Contest</th>
									<th>Metric</th>
									<th>Goal</th>
								</tr>
							</thead>
							<tbody>
								<tr>
									<td>
										Reading
									</td>
									<td>
										<select value={ contest.reading_metric } className="form-control"
										onChange={ this.onSelectReadingMetric.bind(this, school) }>
											{ DropDownOptions.Select.contestReadingMetrics() }
										</select>
									</td>
									<td>
										<input className="form-control input" type="numder" onChange={this.onSetGoal.bind(this, school, "reading_goal")} defaultValue={contest.reading_goal} />
									</td>
								</tr>
								<tr>
									<td>
										Writing
									</td>
									<td>
										<select value={ contest.writing_metric } className="form-control"
										onChange={ this.onSelectWritingMetric.bind(this, school) }>
											{ DropDownOptions.Select.contestWritingMetrics() }
										</select>
									</td>
									<td>
										<input className="form-control input" type="numder" onChange={this.onSetGoal.bind(this, school, "writing_goal")} defaultValue={contest.writing_goal} />
									</td>
								</tr>
							</tbody>
						</table>
					</div>
					{ saveAction }
				</div>
			)
		})
	}

	onLinkSchoolPage() {
		$wr.redirect("/contests");
	}

	onSave(schoolOrg) {
		this.props.onChange(schoolOrg)
		this.state.save = _.select(this.state.save, (id) => id != schoolOrg.id)
		this.setState({save: this.state.save})
	}

	render() {

		return (
			<div className="SchoolContestPreference">
				Contests are displayed on the <a onClick={this.onLinkSchoolPage}>School page</a>
				<br/>

				{this.renderselectedSchoolOrgs()}
			</div>
		)
	}

}


SchoolContestPreference.WrappedComponent.propTypes = StrictPropTypes({
	onChange: PropTypes.func.isRequired
});

module.exports = SchoolContestPreference;


// WEBPACK FOOTER //
// ./modules/components/org/preferences/SchoolContestPreference.js